export const heroSlides = [
  {
    id: "hero-1",
    label: "午夜首映",
    title: "雨夜迷踪",
    subtitle: "一场暴雨，一盘磁带，和整条街都不愿提起的夜晚。",
    meta: "2025 · 悬疑 · 118 分钟",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20rain-soaked%20dark%20city%20street%20at%20midnight%2C%20lone%20figure%20with%20umbrella%20walking%20away%20under%20glowing%20amber%20neon%20signs%2C%20deep%20navy%20blue%20shadows%2C%20wet%20reflective%20asphalt%2C%20heavy%20atmosphere%20with%20mist%20and%20rain%20streaks%2C%20dramatic%20moody%20lighting%2C%20high%20detail%2C%20no%20text%20and%20no%20lettering&width=1600&height=900&seq=hero-midnight-01&orientation=landscape",
    href: "/detail/movie/m001",
  },
  {
    id: "hero-2",
    label: "本周热映",
    title: "霓虹尽头",
    subtitle: "当最后一块灯牌熄灭，真相才刚刚亮起。",
    meta: "2025 · 犯罪 · 124 分钟",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20rooftop%20view%20over%20a%20vast%20neon%20city%20at%20midnight%20in%20deep%20navy%20fog%2C%20silhouetted%20detective%20figure%20in%20the%20foreground%2C%20glowing%20amber%20signage%20and%20light%20trails%20far%20below%2C%20atmospheric%20noir%20lighting%2C%20rain%20mist%2C%20high%20detail%2C%20no%20text%20and%20no%20lettering&width=1600&height=900&seq=hero-midnight-02&orientation=landscape",
    href: "/detail/movie/m002",
  },
  {
    id: "hero-3",
    label: "短视频精选",
    title: "深夜厨房：一碗热汤面",
    subtitle: "凌晨两点半，为自己煮一碗面，也为这一夜收个尾。",
    meta: "生活 · 04:12 · 夜航影像",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20night%20kitchen%20scene%20with%20a%20steaming%20bowl%20of%20noodles%20on%20a%20wooden%20table%2C%20warm%20amber%20pendant%20lamp%20against%20deep%20navy%20darkness%2C%20soft%20steam%20rising%2C%20window%20showing%20dark%20city%2C%20cozy%20intimate%20midnight%20atmosphere%2C%20high%20detail%2C%20no%20text%20and%20no%20lettering&width=1600&height=900&seq=hero-midnight-03&orientation=landscape",
    href: "/detail/short-video/s001",
  },
];

export const movieGenres = ["全部", "悬疑", "犯罪", "恐怖", "剧情", "科幻", "动作", "爱情"];

export const movieRegions = ["全部地区", "中国", "欧美", "日韩", "港台"];

export const movieYears = ["全部年份", "2025", "2024", "2023", "2022", "2021", "2020", "2015", "2012"];

export const movieSorts = [
  { value: "newest", label: "上映时间降序" },
  { value: "heat", label: "热度降序" },
  { value: "classic", label: "经典优先（年份升序）" },
];

export const shortTags = ["全部", "剧情", "生活", "搞笑", "剪辑"];

export const shortSorts = [
  { value: "newest", label: "最新发布" },
  { value: "hot", label: "最热播放" },
];

export const siteHighlights = [
  { label: "在库影片", value: "1,280+", icon: "ri-film-line" },
  { label: "精选短视频", value: "3,600+", icon: "ri-play-circle-line" },
  { label: "每日更新", value: "48 部", icon: "ri-time-line" },
  { label: "深夜在线", value: "12.6 万", icon: "ri-moon-line" },
];

export const contactInfo = {
  email: "hello@midnight-video.example",
  response: "工作日 24 小时内回复",
  address: "线上运营 · 深夜不打烊",
  hours: "每日 20:00 - 次日 05:00",
};